module.exports = __webpack_public_path__ + "kudos_31.svg?6cd1dbb75bee9b05f89618f89d81e042";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_31.svg
// module id = 130
// module chunks = 0